import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  trackEvent as trackEventAction,
  trackPage as trackPageAction,
} from 'actions/analytics/tracking';

const useTracking = () => {
  const dispatch = useDispatch();

  const trackEvent = useCallback(
    (eventName: string, data?: Record<string, unknown>) => {
      return dispatch(trackEventAction(eventName, data) as any);
    },
    [dispatch],
  );

  const trackPage = useCallback(
    (data?: Record<string, unknown>) => {
      return dispatch(trackPageAction(data) as any);
    },
    [dispatch],
  );

  return {
    trackEvent,
    trackPage,
  };
};

export default useTracking;